import { dataPaperPlaneSendSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPaperPlaneSendSolid = /*#__PURE__*/createIcon(dataPaperPlaneSendSolid)
export default IconPaperPlaneSendSolid
